import { CalendarCheck, Check, Globe2 } from "lucide-react";
import { HOME_WRAP, SectionEyebrow } from "./HomeShared";
import { useAppointment } from "../../context/AppointmentContext";
import meetDoctorImage from "../../assets/meetdoctor.svg";

export default function DentistSection() {
  const { openAppointment } = useAppointment();

  return (
    <section className={`${HOME_WRAP} grid gap-10 py-20 md:grid-cols-2 md:items-center`}>
      <div className="mx-auto w-full max-w-[500px] md:mx-0 md:justify-self-center">
        <img src={meetDoctorImage} alt="Dr. Yanahitza Baro" className="h-auto w-full" />
      </div>
      <div>
        <SectionEyebrow>Meet Your Dentist</SectionEyebrow>
        <h2 className="text-[38px] font-bold leading-tight text-[#071746] md:text-[48px]">Dr. Yanahitza Baro</h2>
        <p className="mt-5 max-w-[640px] text-[17px] font-medium leading-relaxed text-[#4d5b7c]">
          Be Dental Paradise is led by <strong className="text-[#071746]">Dr. Yanahitza Baro</strong>, a Cuban dentist specializing in <strong className="text-[#071746]">general dentistry and prosthodontist rehabilitation</strong> with more than <strong className="text-[#071746]">20 years of clinical experience</strong>. From a first cleaning to full smile rehabilitation, every patient leaves with results - and confidence - from the very first visit.
        </p>
        <ul className="mt-8 space-y-4 text-[15px] text-[#071746]">
          <li className="flex items-center gap-3 text-[#4d5b7c]"><Globe2 className="h-5 w-5 text-[#0052ff]" /> English & SpanishㆍCaribbean-inspired care</li>
          {["General dentistry & prosthodontist rehabilitation", "20+ years of clinical practice", "Personalized care plans for every patient", "Bilingual consultations (English & Spanish)"].map((item) => (
            <li key={item} className="flex items-center gap-3">
              <span className="grid h-5 w-5 place-items-center rounded-full bg-[#c9f8eb] text-[#079b65]"><Check className="h-4 w-4" /></span>
              {item}
            </li>
          ))}
        </ul>
        <button
          type="button"
          onClick={openAppointment}
          className="mt-8 inline-flex h-[52px] items-center justify-center gap-2 rounded-[10px] bg-[#0052ff] px-7 text-[16px] font-bold text-white shadow-[0_16px_34px_rgba(0,82,255,0.22)] transition hover:bg-[#003ec2]"
        >
          <CalendarCheck className="h-5 w-5" />
          Schedule a Visit
        </button>
      </div>
    </section>
  );
}
